import { PageTypeId } from '../../const';
import { NavigationModuleSchema } from '../../types';
import { navigationCodes } from '../../../../data/translations/navigationCodes';
import { caoWijzerNavigationCodes } from '../../../../data/translations/caoWijzerNavigationCodes';

export const caoWijzerUserNavigationSchema: NavigationModuleSchema = [
	{
		titleCode: caoWijzerNavigationCodes.dashboard,
		pageTypeId: PageTypeId.Dashboard,
	},
	{
		titleCode: caoWijzerNavigationCodes.caoNewsList,
		pageTypeId: PageTypeId.CaoNewsList,
	},
	{
		titleCode: caoWijzerNavigationCodes.cao,
		pageTypeId: PageTypeId.CaoList,
	},
	{
		titleCode: caoWijzerNavigationCodes.caoInstanceList,
		pageTypeId: PageTypeId.CaoInstanceList,
	},
	{
		titleCode: caoWijzerNavigationCodes.caoWagesList,
		pageTypeId: PageTypeId.CaoWagesList,
	},
	{
		titleCode: caoWijzerNavigationCodes.caoWagesRequestsList,
		pageTypeId: PageTypeId.CaoWagesRequestsList,
	},
	{
		titleCode: caoWijzerNavigationCodes.wmlList,
		pageTypeId: PageTypeId.CaoWmlList,
	},
];


export const caoWijzerAdminNavigationSchema: NavigationModuleSchema = [
	{
		titleCode: navigationCodes.user,
		pageTypeId: PageTypeId.UserList,
	},
	{
		titleCode: navigationCodes.savedFilter,
		pageTypeId: PageTypeId.SavedFilterMyFiltersList,
		childrenPageTypeIds: [
			PageTypeId.SavedFilterSystemFiltersList,
			PageTypeId.SavedFilterOtherUsersFiltersList,
			PageTypeId.SavedFilterAlertLogsList,
		],
	},
];
